import { useMemo } from 'react';

import { keyOf } from '@Components/Grid/components/Table/formatters';
import { defaultActionsColumn, defaultColumn, deleteAction } from '@Components/Grid/utils/column';

import DetailsEntityFormatter from './DetailsEntityFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumn('ip', 'IP Address'),
    defaultColumn('reason', 'Blocking Reason'),
    defaultActionsColumn(detailsAction, deleteAction),
  ], [])
}

export function detailsAction(info) {
  return <DetailsEntityFormatter key={keyOf(info, 'details')} info={info} />
}
